import React, { useState } from 'react';
import { Form, Input, Button, Radio, Row, Col, DatePicker, Typography, message } from 'antd';
import firebase, { auth, firestore, storage } from 'firebase/app';
import { refs } from '../../firebase/firebase';
import { useDriverContext } from '../../context/DriverContext';

const { Title } = Typography;

const Step2 = ({ form, next, prev, }) => {
  const [loading, setLoading] = useState(false);
  const { setDriverName } = useDriverContext();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const emailExistsQuery = await refs.registrations.where('email', '==', values.email).get();
      if (!emailExistsQuery.empty) {
        message.error('Email already exists');
        setLoading(false);
        return;
      }
      // logData(values); // Log the data
      setDriverName({ firstName: values.firstName, lastName: values.lastName });
      next(); // Proceed to the next step
    } catch (error) {
      console.error('Registration failed:', error);
      message.error('Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const validateAustralianPhoneNumber = (_, value) => {
    const phoneRegex = /^(?:\+61|0)[2-478](?:[ -]?[0-9]){8}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject('Please enter a valid Australian phone number');
  };

  const validateABN = (_, value) => {
    const abnRegex = /^\d{11}$/;
    if (!value || abnRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject('ABN must be exactly 11 digits');
  };

  return (
    <div>
      <Title level={2}>Your Information</Title>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        {/* <Form.Item name="gmCabsUser" label="Are you a Opera Taxis Terminal User" rules={[{ required: true }]}>
          <Radio.Group>
            <Radio value="yes">Yes</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
        </Form.Item> */}
        <Form.Item name="driversLicenseNumber" label="Drivers License Number" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="firstName" label="First Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="lastName" label="Last Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        {/* <Form.Item name="preferredName" label="Preferred Name / Nick Name">
          <Input />
        </Form.Item> */}
        <Form.Item
          name="phoneNumber"
          label="Phone Number"
          rules={[
            { required: true, message: 'Please enter your phone number' },
            { validator: validateAustralianPhoneNumber }
          ]}
        >
          <Input placeholder="e.g. 0412345678 or +61412345678" />
        </Form.Item>
        <Form.Item name="address" label="Address" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="dob" label="Date of Birth" rules={[{ required: true }]}>
          <DatePicker format="DD-MM-YYYY" />
        </Form.Item>
        <Form.Item
          name="abnNumber"
          label="ABN Number"
          rules={[
            { required: true, message: 'Please enter your ABN number' },
            { validator: validateABN }
          ]}
        >
          <Input placeholder="11 digit ABN number" maxLength={11} />
        </Form.Item>
        <Button style={{ marginRight: 20 }} type="primary" onClick={prev}>Back</Button>
        <Button type="primary" htmlType="submit" loading={loading}>Next</Button>
      </Form>
    </div>
  );
};

export default Step2;
